package gr.tech.contactpage.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.BoxShadow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import gr.tech.contactpage.components.sections.SalesforceContactForm
import gr.tech.contactpage.styles.Theme
import gr.tech.contactpage.styles.cappedWidth
import gr.tech.contactpage.util.bearHuntingForm
import gr.tech.contactpage.util.porridgeTimer
import kotlinx.browser.window
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import kotlin.io.encoding.Base64.Default.decode

@Page
@Composable
fun HomePage() {
    val context = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    porridgeTimer.startTimer()

    val leadSource = context.route.params["source"] ?: "Green Rebates Website Contact Form"
    val stateParam = context.route.params["state"] ?: ""
    val utilParam = context.route.params["utility"] ?: ""

    Box(Modifier
        .backgroundColor(Theme.MediumGreen.rgb)
        .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .margin(
                    top = if (breakpoint < Breakpoint.MD) 1.cssRem else 54.px,
                    bottom = 50.px
                )
                .padding(
                    topBottom = 16.px,
                    leftRight = 16.px
                )
                .boxShadow(BoxShadow.of(
                    offsetX = 0.px,
                    offsetY = 10.px,
                    blurRadius = 15.px,
                    spreadRadius = 10.px,
                    color = Color.rgba(0,0,0,0.3.toFloat())
                ))
                .cappedWidth()
                .backgroundColor(Theme.LightGray.rgb)
                .borderRadius(5.px)
            ,
            verticalArrangement = Arrangement.Top
        ) {
            bearHuntingForm()
            Img(
                src = "grlogocenter.png",
                alt = "Green Rebates",
                attrs = Modifier
                    .fillMaxSize()
                    .toAttrs()
            )
            P {
                Text("We can't wait to put some cash back in your pocket! Fill out the form below, and our team with get to work creating an estimate for your rebate.  The more information you can provide, the faster we can Show You the Money!  Whether your starting a new project or just have a question, we're here to help.")
            }
            SalesforceContactForm(
                breakpoint = breakpoint,
                leadSource = leadSource,
                state = stateParam,
                util = utilParam
            )
        }
    }
}
